export default __webpack_public_path__ + "309cd4a.png";